import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Separator from '@/components-latest/primitives/Separator'
import { formatCampaignCurrencyAmount } from '@/ducks/campaigns/campaigns.helpers'
import type { CartDiscountCampaign } from '@/ducks/campaigns/campaigns.types'
import { selectCurrencySymbol } from '@/ducks/store/selectors/store.selectors'

import CampaignDetailsDottedRow from './CampaignDetailsDottedRow'
import Styles from './CampaignDetailsModal.module.scss'

type Props = {
  campaign: CartDiscountCampaign
}

const CartDiscountDetails = ({ campaign }: Props) => {
  const { t } = useTranslation()
  const currency = useSelector(selectCurrencySymbol) || ''

  return (
    <>
      <Separator />
      <div className={Styles.section}>
        <h3 className={Styles.sectionTitle}>
          {t('marketing.campaigns.details.discount-details')}
        </h3>
        <div className={Styles.dottedRows}>
          <CampaignDetailsDottedRow
            label={t('marketing.campaigns.details.minimum-amount')}
            value={formatCampaignCurrencyAmount(campaign.targetAmount, currency)}
          />
          <CampaignDetailsDottedRow
            label={t('marketing.campaigns.details.maximum-off')}
            value={formatCampaignCurrencyAmount(campaign.maxOff, currency)}
          />
        </div>
      </div>
    </>
  )
}

export default CartDiscountDetails
